module.exports = __webpack_public_path__ + "img/cedric_villani_rounded_gray.6bfd5f79.jpg";